let language = {
    DETAIL_DESIGN_SELLING: "开售",
    DETAIL_DESIGN_TITLE: "订购样品",
    DETAIL_DESIGN_TITLE_MOBILE: "订单样品",    
    DETAIL_INPUT_ERROR_TITLE:"输入无效",
    DETAIL_INPUT_ERROR:"产品属性包含非法输入值。请做必要的修改后再试。",
}

export { language }